module.exports = __webpack_public_path__ + "static/media/decoration-certification.84a862f4.png";